import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=1ffdda66&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=1ffdda66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffdda66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffdda66')) {
      api.createRecord('1ffdda66', component.options)
    } else {
      api.reload('1ffdda66', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=1ffdda66&scoped=true&", function () {
      api.rerender('1ffdda66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/contract/apply/edit.vue"
export default component.exports